import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Toggle from "../../utils/toggle";

const Nav = ({ page, nav }) => {
  

  return (
    <nav className="hidden lg:block">
      <ul className={"flex " + (page === "page" ? "page" : "")}>
        {nav.main_nav_items.map((nav, index) => {
          return (
            <li key={index}>
              <button
                type="button"
                className="nav-item"
                onClick={Toggle}
                aria-expanded="false"
              >
                <span className="sr-only">Open &quot;</span>
                {nav.nav_label}
                <span className="sr-only">&quot; menu</span>
              </button>
              <div className="dd flex">
                <ul className="nav-items">
                  {nav.drop_down.document.data.sub_nav_item.map(
                    (snav, index) => {
                      if (snav.sub_nav !== null) {
                        return (
                          <li
                            key={index}
                            className={
                              "flex multi " + nav.drop_down.document.data.theme
                            }
                          >
                            <div className="multi-link">
                              <Link
                                className="flex justify-between"
                                to={snav.nav_link.url}
                              >
                                <span className="nav-content">
                                  <span className="nav-title">
                                    {snav.nav_label}
                                    <i className="fa-solid fa-angle-right"></i>
                                  </span>
                                  <span>
                                    <PrismicRichText
                                      field={snav.nav_context.richText}
                                    />
                                  </span>
                                </span>
                              </Link>
                              <div className="multi-box">
                                {snav.sub_nav.document.data.sub_nav_item.map(
                                  (ssnav, index) => {
                                    return (
                                      <Link key={index} to={ssnav.nav_link.url}>
                                        {ssnav.nav_label}
                                        <i className="fa-solid fa-angle-right" />
                                      </Link>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </li>
                        );
                      }
                      return (
                        <li
                          key={index}
                          className={
                            "flex multi " + nav.drop_down.document.data.theme
                          }
                        >
                          <div className="multi-link">
                            <Link
                              className="flex justify-between"
                              to={snav.nav_link.url}
                            >
                              <span className="nav-content">
                                <span className="nav-title">
                                  {snav.nav_label}
                                  <i className="fa-solid fa-angle-right"></i>
                                </span>
                                <span>{snav.nav_context.text}</span>
                              </span>
                            </Link>
                          </div>
                        </li>
                      );
                    }
                  )}
                </ul>
                <div className="fea-item">
                  <div className="nav-feature flex-col px-8 multi flex">
                    <span className="!p-0 shadow-lg mb-4">
                      <GatsbyImage
                        image={getImage(nav.resource.document.data.meta_image)}
                        alt={
                          nav.resource.document.data.meta_image.alt ||
                          nav.resource.document.data.resource_title.text
                        }
                        className="rounded-lg"
                      />
                    </span>
                    <div className="nav-content">
                      <span className="nav-title leading-tight font-bold mb-2">
                        {nav.resource.document.data.resource_title.text}
                      </span>
                      <span className="nav-desc text-grey text-sm mb-4">
                        {nav.resource.document.data.description.text}
                      </span>
                      <Link to={nav.resource.document.url}>
                        <span className="btn text-sm bg-yellow">Learn more</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
